import { BannerIcon, MessagingBannerState, getMessagingBanner, bannerHasNoErrors } from 'redux/slices/messagingBanner'

import Countdown from 'react-countdown-now'
import React, { useMemo } from 'react'
import clsx from 'clsx'
import { getFormattedShowStartTime, showHasEnded, showIsSoldOut } from 'utils/show'
import { getRemainingPasses, getShow, getShowPreview, PreviewState } from 'redux/slices/liveShow'
import { isNil } from 'lodash'
import { useSelector } from 'react-redux'
import useStyles from './styles'

export const MessagingBanner: React.FC = () => {
    const show = useSelector(getShow)!
    const remainingPasses = useSelector(getRemainingPasses)
    const startTime = show.startTime
    const showEnded = showHasEnded(show)
    const showSoldOut = showIsSoldOut(remainingPasses)

    const preview = useSelector(getShowPreview)
    const banner: MessagingBannerState = useSelector(getMessagingBanner)
    const noErrors = useSelector(bannerHasNoErrors)
    const classes = useStyles()

    const remainingTime = useMemo(() => (preview.state === PreviewState.STARTED ? preview.endTime! : startTime), [
        preview,
        startTime,
    ])
    const showCountdown = useMemo(() => !showSoldOut && !showEnded && noErrors, [showSoldOut, showEnded, noErrors])

    const showIcon = useMemo(() => banner.icon !== BannerIcon.NONE, [banner.icon])

    const showMessage = useMemo(() => !isNil(banner.message), [banner.message])

    return (
        <div className={classes.messagingBanner}>
            <div
                className={clsx(
                    classes.root,
                    isNil(banner.message) && classes.iconNoMsg,
                    classes[`status-${banner.status}`],
                )}
                data-testid="messaging-banner"
            >
                {showIcon && (
                    <span
                        className={clsx(classes.icon, classes[`icon-${banner.icon}`])}
                        data-testid="messaging-banner-icon"
                    />
                )}

                <div className={classes.body}>
                    <div className={classes.content}>
                        {showMessage && (
                            <p className={classes.message} data-testid="messaging-banner-message">
                                {banner.message}
                            </p>
                        )}

                        <span className={classes.showInfo}>{getFormattedShowStartTime(startTime)}</span>
                    </div>

                    {showCountdown && (
                        <span className={classes.countdown}>
                            <Countdown key={remainingTime} date={remainingTime} />
                        </span>
                    )}
                </div>
            </div>
        </div>
    )
}

export default React.memo(MessagingBanner)
